export default __webpack_public_path__ + "static/media/Nainital02.565ea8fb.jpg";